import { render, staticRenderFns } from "./CouponManagement.vue?vue&type=template&id=d65b7112&scoped=true&lang=pug"
import script from "./CouponManagement.vue?vue&type=script&lang=js"
export * from "./CouponManagement.vue?vue&type=script&lang=js"
import style0 from "./CouponManagement.vue?vue&type=style&index=0&id=d65b7112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65b7112",
  null
  
)

export default component.exports